import styled from '@emotion/styled'

export const Wrapper = styled.div`
    margin: 10px;
    border-radius: 16px;
`
export const Title = styled.div`
    margin-bottom: 20px;
    text-align: left;
    display: flex;
    align-items: center;
`

export const Content = styled.div`
    background-color: #fff;
    border-radius: 16px;
    padding: 20px;
    min-height: 80vh;
`

export const Header = styled.header`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`

export const error = {
    color: '#d32f2f',
    marginLeft: 2,
}
